import sanitizeHtmlLib from "sanitize-html";

// Shared HTML sanitizer for CMS / API-sourced content rendered via
// dangerouslySetInnerHTML (blog bodies, FAQ answers, category copy).
// Strips <script>, inline event handlers (on*), and javascript:/unknown-scheme
// URLs while preserving prose formatting + safe media (img, YouTube/Vimeo iframes).
// (CommonCard keeps its own SVG-rich SafeHtml for its specific content.)
const options: sanitizeHtmlLib.IOptions = {
  allowedTags: [
    ...sanitizeHtmlLib.defaults.allowedTags,
    "img", "h1", "h2", "figure", "figcaption", "span", "section",
    "article", "header", "footer", "iframe", "video", "source", "picture",
    "u", "s", "sup", "sub", "hr",
  ],
  allowedAttributes: {
    ...sanitizeHtmlLib.defaults.allowedAttributes,
    "*": ["class", "style", "id", "dir", "align", "title"],
    img: ["src", "alt", "title", "width", "height", "loading", "decoding"],
    a: ["href", "name", "target", "rel"],
    iframe: ["src", "width", "height", "allow", "allowfullscreen", "frameborder", "loading"],
    video: ["src", "controls", "width", "height", "poster"],
    source: ["src", "type"],
  },
  allowedSchemes: ["http", "https", "mailto", "tel", "data"],
  allowedSchemesByTag: { img: ["http", "https", "data"], iframe: ["http", "https"] },
  allowedIframeHostnames: ["www.youtube.com", "youtube.com", "player.vimeo.com", "www.loom.com", "calendly.com"],
  disallowedTagsMode: "discard",
  enforceHtmlBoundary: false,
  transformTags: {
    '*': (tagName, attribs) => {
      const clean = { ...attribs };
      if (clean.style) {
        clean.style = clean.style.split(';').filter((declaration) =>
          !/^\s*mso-/i.test(declaration) && !/file\s*:/i.test(declaration)
        ).join(';');
      }
      return { tagName, attribs: clean };
    },
  },
  exclusiveFilter: (frame) => frame.tag === 'img' &&
    (!frame.attribs.src || /^file:/i.test(frame.attribs.src)),
};

/** Sanitize untrusted HTML before rendering via dangerouslySetInnerHTML. */
export const sanitizeHtml = (dirty?: string | null): string =>
  dirty ? sanitizeHtmlLib(dirty, options) : "";
